import SegmentedControl from 'antd-mobile/lib/segmented-control';
export default SegmentedControl;



// WEBPACK FOOTER //
// ./components/segmented-control/index.tsx